export const INVOICE_WRITEOFF_RECORDS_TYPES = [
  {
    id: 'IV',
    name: 'Tax Invoice',
  },
] as const;
